export const environment = {
    production: false,
    hash: "",
    msal: {
        clientId: 'e858b7f4-bf31-4a23-a6f3-d7eaa7693236',
        tenantId: '950af356-6025-4fdb-96a0-a9be6b893fec',
        // redirect: 'http://localhost:4200'
        redirect: 'https://driver.tch.dmp.airproducts.com'
    },
    api: {
        // uri: 'https://graph.microsoft.com/v1.0/me',
        uri: 'https://api.dev.dmp.airproducts.com/',
        backendVersion: 'v1.0/',
        // scopes: ['user.read']
        scopes: ['api://e858b7f4-bf31-4a23-a6f3-d7eaa7693236/API']
    },
    link: {        
        evcr: 'https://tch.fuelmgmt.airproducts.com'
    }
};